import { VisitProduct, baseVisitProduct } from "@/entity/visits/vProducts";

export interface Product extends baseVisitProduct {
    /*product_id: number;
    quantity: number;
    service_id: number;*/
    store_id?: number | null;
    price?: number;
}

interface pData {
    id: number;
    product: Product;
}

export class ProductsDataForm {
    productsData: Product[];

    constructor() {
        this.productsData = [];
    }
    async assignProducts(products: VisitProduct[] | null): Promise<void> {
        products?.map((vProduct: VisitProduct) => {
            const product = {} as Product;
            Object.assign(product, vProduct);
            //this.productsData?.push(product);
        });
    }
    getQuantityService(service_id: number): number {
        let sData = 0;
        this.productsData
            ?.filter((product) => product.service_id === service_id)
            .map((product) => {
                sData = sData + Number(product.quantity);
            });
        return Number(sData);
    }

    async addProduct(service_id: number): Promise<void> {
        const product = {} as Product;

        product.service_id = service_id;
        product.store_id = null;
        product.product_id = null;

        this.productsData.push(product);

        /* if (!this.productsData[service_id]) {
            this.productsData[service_id] = product;
        } else {
            //this.productsData[service_id].push(product);
        }*/

        //push({service_id, product});

        /*debugger

            if (!this.productsData[service_id]) {

                this.productsData[service_id] = new Array(product)
            } else {
                //const data = new Array(product)
                // @ts-ignore
                this.productsData[service_id].push(product);
            }*/

        //([])['myKey']
        //this.productsData?[service_id] = product;

        //this.productsData?.push({service_id:product});
    }

    async deleteProduct(service_id: number, id: number): Promise<void> {
        /*this.productsData?.splice(
            this.productsData[service_id]?.findIndex(function (productIndex) {
                return productIndex["product_id"] === id;
            }),
            1,
        );*/
    }

    getProducts(service_id: number): Product[] | undefined {

        return this.productsData?.filter((product) => product.service_id === service_id);
    }
}
